import { BottomSheet, } from '@rneui/base/dist/BottomSheet/BottomSheet';
import { withTheme } from '../config';
export { BottomSheet };
export default withTheme(BottomSheet, 'BottomSheet');
